/* CAF attribution capture — stores first-touch UTM/click-id/referrer data
   in localStorage, then writes it onto the cart as attributes so it carries
   through to checkout (and shows up on AbandonedCheckout.customAttributes /
   Order.customAttributes in Admin). */
(function () {
  try {
    var STORAGE_KEY = 'caf_attribution';
    var params = new URLSearchParams(window.location.search);
    var clickKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'igshid', 'ttclid'];
    var found = {};
    clickKeys.forEach(function (k) {
      var v = params.get(k);
      if (v) found[k] = v;
    });

    var stored = null;
    try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}

    var hasSignal = Object.keys(found).length > 0 || (document.referrer && document.referrer.indexOf(window.location.hostname) === -1);

    if (!stored && hasSignal) {
      var source = found.utm_source || (found.gclid ? 'google' : (found.fbclid ? 'facebook' : (found.igshid ? 'instagram' : null))) || (document.referrer ? new URL(document.referrer).hostname : 'direct');
      var medium = found.utm_medium || (found.gclid ? 'cpc' : ((found.fbclid || found.igshid) ? 'paid_social' : (document.referrer ? 'referral' : 'direct')));

      stored = {
        source: source,
        medium: medium,
        campaign: found.utm_campaign || '',
        term: found.utm_term || '',
        content: found.utm_content || '',
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || 'direct',
        first_seen: new Date().toISOString()
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    }

    if (stored) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Attribution Source': stored.source || '',
            'Attribution Medium': stored.medium || '',
            'Attribution Campaign': stored.campaign || '',
            'Attribution Landing Page': stored.landing_page || '',
            'Attribution Referrer': stored.referrer || '',
            'Attribution First Seen': stored.first_seen || ''
          }
        })
      }).catch(function () {});
    }
  } catch (e) {}
})();
